import { Stack } from '@findy-code/yuffie/ui/stack';
import type { ComponentProps, ReactNode } from 'react';
import { useEffect, useRef } from 'react';

import { HamburgerMenuButton } from '../button';
import styles from './drawer.component.module.scss';

type Props = {
  children: ReactNode;
  isOpen: boolean;
  onRequestClose: () => void;
} & ComponentProps<'div'>;

// TODO: フォーカストラップ追加
// MEMO: 共通化やサーバーサイドの処理を考慮しつつ react-modal もしくは他のライブラリの使用も検討する
export const Drawer = ({
  children,
  isOpen,
  onRequestClose,
  className,
  ...rest
}: Props) => {
  const menuRef = useRef<HTMLDivElement>(null);

  // memo:
  // テスト可能にするため useEffect で inert を設定
  // 必要性が感じられなかったのでクリーンアップしていない
  useEffect(() => {
    if (menuRef.current) {
      menuRef.current.inert = !isOpen;
    }
  }, [isOpen]);

  useEffect(() => {
    document.body.classList.toggle(styles.noScroll, isOpen);
    return () => {
      document.body.classList.remove(styles.noScroll);
    };
  }, [isOpen]);

  return (
    <div
      className={[className, styles.container].filter(Boolean).join(' ')}
      role="presentation"
      {...rest}
    >
      <div
        aria-hidden
        className={styles.overlay}
        data-is-open={isOpen}
        onClick={onRequestClose}
      />
      <Stack
        aria-label="ヘッダーメニュー"
        aria-modal="true"
        className={styles.drawer}
        data-is-open={isOpen}
        ref={menuRef}
        role="dialog"
        spacing="xxs"
        tabIndex={-1}
      >
        <div className={styles.closeButtonWrapper}>
          <HamburgerMenuButton aria-label="閉じる" onClick={onRequestClose}>
            <svg
              aria-hidden
              fill="currentColor"
              height="20"
              viewBox="0 0 20 20"
              width="20"
            >
              <path d="M13.0327 10L17.5814 5.45136C18.1395 4.89318 18.1395 3.98818 17.5814 3.42955L16.5705 2.41864C16.0123 1.86045 15.1073 1.86045 14.5486 2.41864L10 6.96727L5.45136 2.41864C4.89318 1.86045 3.98818 1.86045 3.42955 2.41864L2.41864 3.42955C1.86045 3.98773 1.86045 4.89273 2.41864 5.45136L6.96727 10L2.41864 14.5486C1.86045 15.1068 1.86045 16.0118 2.41864 16.5705L3.42955 17.5814C3.98773 18.1395 4.89318 18.1395 5.45136 17.5814L10 13.0327L14.5486 17.5814C15.1068 18.1395 16.0123 18.1395 16.5705 17.5814L17.5814 16.5705C18.1395 16.0123 18.1395 15.1073 17.5814 14.5486L13.0327 10Z" />
            </svg>
          </HamburgerMenuButton>
        </div>
        <div className={styles.drawerContentWrapper}>{children}</div>
      </Stack>
    </div>
  );
};
